import { AnalystProfileService } from "./feature/main/tech-analyst/shared/services/analyst-profile.service";
import { ModalModule } from "ngx-bootstrap/modal";
import { AccountModule } from "./feature/external/account/account.module";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { CustomFormsModule } from "ng2-validation";
import { FormsModule } from "@angular/forms";
import { BlockUIModule } from 'ng-block-ui';

import { AppComponent } from "./app.component";
import { AppRoutingModule } from ".//app-routing.module";
import { FooterComponent } from "./core/footer/footer.component";

import { LeftNavMenuComponent } from "./core/left-nav-menu/left-nav-menu.component";
import { TopNavBarComponent } from "./core/top-nav-bar/top-nav-bar.component";
import { PublicPageComponent } from "./feature/external/public-page/public-page.component";
import { PageNotFoundComponent } from "./feature/external/page-not-found/page-not-found.component";
import { AppSharedModule } from "./shared/app-shared.module";
import { RouterModule } from "@angular/router";
import { HttpModule } from "@angular/http";
import { Ng2TelInputModule } from "ng2-tel-input";

import { AppStateService } from "./shared/services/app-state.service";
import { AccountService } from "@app/feature/external/account/shared/services/account.service";
import { LoaderService } from "@shared/services/loader.service";
import { AuthenticationService } from "@shared/services/authentication.service";
import { AuthGuard } from "@shared/services/auth-guard.service";
import { RolesSharedModule } from "@app/feature/main/roles-shared/roles-shared.module";
import { NgxTypeaheadModule } from "ngx-typeahead";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SignInComponent } from "./feature/sign-in/sign-in.component";
import { LinkComponent } from "./feature/external/link/link.component";
import { PrivacyPolicyComponent } from "./feature/external/privacy-policy/privacy-policy.component";
import { AccessToken } from "@app/util/accessToken";
import { AboutUsComponent } from "@app/feature/external/about-us/about-us.component";
import { CookieLawModule } from "angular2-cookie-law";
import { NguiAutoCompleteModule } from "@ngui/auto-complete";

import { UserDetailService } from "@app/feature/main/roles-shared/services/user-detail.service";
import { Breadcrumb } from "primeng/breadcrumb";
import { ClickOutsideModule } from "ng4-click-outside";
import { LinkedinResolverService } from "./linkedin-resolver.service";
import { LikedinService } from "./likedin.service";
import { OneSignalService } from "@app/onesignal.service";
import { TechDomainService } from "@app/shared/services/tech-domain.service";
import { OurServicesComponent } from './feature/external/our-services/our-services.component';
import { SsoLoginService } from "./shared/services/sso-login.service";
import { SsoGetResponseComponent } from "@app/feature/sso-get-response/sso-get-response.component";
import { SsoSignupResponseComponent } from '@app/feature/sso-signup-response/sso-signup-response.component';
import { GlobalDataSharedService } from "./feature/main/roles-shared/services/global-data-shared-service.service";
import { VersionCheckService } from "./shared/services/version-check.service";
import { AuthMyProjectsService } from "./feature/main/roles-shared/components/my-projects/auth-guard-my-projects.service";
import { ToastrService } from "ngx-toastr";
import { CreateProjectService } from "./shared/services/create-project/create-project.service";

@NgModule({
  declarations: [
    AppComponent,
    SignInComponent,
    LinkComponent,
    AboutUsComponent,
    OurServicesComponent,
	  SsoGetResponseComponent,
	  SsoSignupResponseComponent
  ],
  imports: [
    BrowserModule,
    AppSharedModule,
    RolesSharedModule,
    AppRoutingModule,
    FormsModule,
    CustomFormsModule,
    RouterModule,
    Ng2TelInputModule,
    NgxTypeaheadModule,
    BrowserAnimationsModule,
    CookieLawModule,
    NguiAutoCompleteModule,
    ClickOutsideModule,
    BlockUIModule.forRoot()
  ],
  exports: [Ng2TelInputModule, BrowserAnimationsModule],
  providers: [
    AppStateService,
    LoaderService,
    AuthenticationService,
    AuthGuard,
    AccessToken,
    AuthMyProjectsService,
    UserDetailService,
    LinkedinResolverService,
    LikedinService,
    OneSignalService,
    TechDomainService,
    AnalystProfileService,
    SsoLoginService,
    GlobalDataSharedService,
    VersionCheckService,
    ToastrService,
    CreateProjectService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts